/* Salmatcha · product page buying aids (2 Nov 2026). Loaded on product templates only.
   1. One-time purchase is the default. Subscriptions were pre-selected and 10 of 33 renewals
      were refunded (vs 2 of 863 web orders), so customers now opt in on purpose.
   2. When a subscription is chosen, one line states the commitment in AED.
   3. Size buttons carry servings, price per serving and the bulk saving.
   4. Under Add to cart: free-UAE-shipping distance; one real customer quote (inside Details on D2C pages). */
(function () {
  'use strict';
  if (!document.body.classList.contains('template-product')) return;

  var FREE_SHIP = 30000;               // AED 300 in fils — the published free UAE shipping threshold
  var WHISK = '/products/matcha-bamboo-whisk';
  var handle = (location.pathname.split('/products/')[1] || '').split(/[/?#]/)[0];
  if (!handle) return;

  var product = null;
  var userPicked = false;              // set by a real tap on the subscription widget
  var cartTotal = 0;
  var whiskPrice = 0;

  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var aed = function (fils) { return (fils / 100).toFixed(2) + ' AED'; };
  var block = function () { return $('.main-product__block-buy_buttons'); };
  var form = function () { var b = block(); return b && $('form[action*="/cart/add"]', b); };
  var variantId = function () { var f = form(); var i = f && $('[name="id"]', f); return i ? Number(i.value) : null; };
  var planId = function () { var f = form(); var i = f && $('[name="selling_plan"]', f); return i && i.value ? Number(i.value) : null; };
  var qty = function () { var i = $('.main-product__block-buy_buttons [name="quantity"]') || $('[name="quantity"][form]'); var n = i ? parseInt(i.value, 10) : 1; return n > 0 ? n : 1; };
  var setHTML = function (el, html) { if (el.innerHTML !== html) el.innerHTML = html; };  // write only on change, so the observer settles
  var variant = function () { if (!product) return null; var id = variantId(); return product.variants.filter(function (v) { return v.id === id; })[0] || product.variants[0]; };

  /* ---------- 1. one-time purchase by default ---------- */
  document.addEventListener('click', function (e) {
    if (e.isTrusted && e.target.closest && e.target.closest('kaching-subscriptions')) userPicked = true;
  }, true);
  function defaultOneTime() {
    if (userPicked) return;
    var b = block(); if (!b) return;
    var ot = $('.kaching-subscriptions__card-wrapper.one-time-purchase', b);
    if (ot && !ot.classList.contains('selected')) ot.click();
  }

  /* plan + ladder data: Kaching's "change discount after N orders" arrives as two price adjustments */
  function planById(pid) { var plan = null; (product.selling_plan_groups || []).forEach(function (g) { g.selling_plans.forEach(function (p) { if (p.id === pid) plan = p; }); }); return plan; }
  function ladder(v, pid) {
    var plan = planById(pid); if (!plan || !v) return null;
    var alloc = (v.selling_plan_allocations || []).filter(function (a) { return a.selling_plan_id === pid; })[0]; if (!alloc) return null;
    var adj = plan.price_adjustments || [], pa = alloc.price_adjustments || [];
    var m = /every\s+([^|]+)/i.exec(plan.name || '');
    var every = m ? m[1].trim().replace(/^1\s+month$/i, 'month') : '';
    var first = adj[0] || {}, next = adj[1] || null;
    return { every: every, firstPct: first.value_type === 'percentage' ? first.value : null, nextPct: next && next.value_type === 'percentage' ? next.value : null,
      firstPrice: (pa[0] || {}).price || alloc.price, nextPrice: next ? ((pa[1] || {}).price || alloc.price) : null, afterOrders: next ? (first.order_count || 1) : null };
  }
  function pctLine(L) {
    if (!L || L.firstPct === null) return '';
    if (L.nextPct === null) return L.firstPct + '% off every delivery';
    return L.firstPct + '% off now · ' + L.nextPct + '% from your ' + (L.afterOrders === 1 ? '2nd' : (L.afterOrders + 1) + 'th') + ' delivery';
  }

  /* ---------- 2. subscription commitment line ---------- */
  function commitLine() {
    var b = block(); if (!b || !product) return;
    var k = $('kaching-subscriptions', b); if (!k) return;
    var el = $('.sal-commit', b);
    if (!el) { el = document.createElement('p'); el.className = 'sal-commit'; el.setAttribute('aria-live', 'polite'); k.insertAdjacentElement('afterend', el); }
    var pid = planId(), v = variant();
    if (!pid || !v) { if (!el.hidden) el.hidden = true; return; }
    var L = ladder(v, pid);
    if (!L) { if (!el.hidden) el.hidden = true; return; }
    var every = L.every ? 'every ' + L.every : 'on a schedule';
    var q = qty();
    if (L.nextPrice !== null) {
      setHTML(el, '<strong>First delivery ' + aed(L.firstPrice * q) + '.</strong> From the ' + (L.afterOrders === 1 ? 'second' : 'next') + ': ' + aed(L.nextPrice * q) + ' ' + every +
        ', ' + L.nextPct + '% off for as long as you stay. Cancel anytime from your account.');
    } else {
      var save = (v.price - L.firstPrice) * q;
      setHTML(el, '<strong>Subscription: ' + aed(L.firstPrice * q) + ' charged ' + every + '.</strong> ' +
        (save > 0 ? 'You save ' + aed(save) + ' on each delivery. ' : '') +
        'Change or cancel anytime from your account.');
    }
    if (el.hidden) el.hidden = false;
  }

  /* ---------- 3. value inside the size buttons ---------- */
  function servingsFor(id) {
    var s = $('[data-sal-serving-variant="' + id + '"]');
    var m = s && /(\d[\d,]*)\s*servings/i.exec(s.textContent);
    return m ? parseInt(m[1].replace(/,/g, ''), 10) : 0;
  }
  function sizeButtons() {
    if (!product || product.variants.length < 2 || product.options.length !== 1) return;
    var rows = product.variants.map(function (v) { var n = servingsFor(v.id); return { v: v, n: n, per: n ? v.price / n : 0 }; })
      .filter(function (r) { return r.n > 0; });
    if (rows.length !== product.variants.length) return;
    var base = rows.reduce(function (a, r) { return r.per > a ? r.per : a; }, 0);
    var picker = $('.main-product__block-variant_picker'); if (!picker) return;
    $$('.sf-po__option-button', picker).forEach(function (btn) {
      if (btn.dataset.salMeta) return;
      var input = btn.previousElementSibling && btn.previousElementSibling.tagName === 'INPUT' ? btn.previousElementSibling : (btn.htmlFor ? document.getElementById(btn.htmlFor) : null);
      var value = (input && input.value) || btn.textContent.trim();
      var row = rows.filter(function (r) { return r.v.option1 === value || r.v.title === value; })[0];
      if (!row) return;
      btn.dataset.salMeta = '1';
      btn.classList.add('sal-opt');
      var pct = base > 0 ? Math.round((base - row.per) / base * 100) : 0;
      btn.insertAdjacentHTML('beforeend',
        '<span class="sal-opt__meta">' + row.n.toLocaleString('en') + ' servings · ' + aed(Math.floor(row.per)) + ' each</span>' +
        (pct >= 5 ? '<span class="sal-opt__save">Save ' + pct + '%</span>' : ''));
    });
    picker.classList.add('sal-opts-ready');
  }

  /* ---------- 4a. free-shipping distance ---------- */
  function shipLine() {
    var b = block(); if (!b || !product) return;
    var anchor = $('product-form', b) || form(); if (!anchor) return;
    var el = $('.sal-ship', b);
    if (!el) { el = document.createElement('p'); el.className = 'sal-ship'; anchor.insertAdjacentElement('afterend', el); }
    var v = variant(); if (!v) return;
    var pid = planId();
    var alloc = pid && (v.selling_plan_allocations || []).filter(function (a) { return a.selling_plan_id === pid; })[0];
    var unit = alloc ? alloc.price : v.price;
    var left = FREE_SHIP - (cartTotal + unit * qty());
    if (left <= 0) {
      setHTML(el, '<span class="sal-ship__ok">Free UAE shipping on this order</span>');
    } else {
      var tip = (whiskPrice && left <= whiskPrice && handle !== 'matcha-bamboo-whisk')
        ? ' — a <a href="' + WHISK + '">bamboo whisk</a> (' + aed(whiskPrice) + ') gets you there' : '';
      setHTML(el, 'Add ' + aed(left) + ' more for free UAE shipping' + tip);
    }
  }

  /* ---------- 4b. one real customer quote ---------- */
  function quote() {
    var b = block(); if (!b || $('.sal-quote')) return;
    var pick = null;
    $$('.jdgm-rev').some(function (r) {
      var score = Number((($('.jdgm-rev__rating', r) || {}).getAttribute || function () { return 0; }).call($('.jdgm-rev__rating', r), 'data-score'));
      var p = $('.jdgm-rev__body p', r) || $('.jdgm-rev__body', r);
      var text = p ? p.textContent.replace(/Read more\s*$/i, '').replace(/\s+/g, ' ').trim() : '';
      var who = ($('.jdgm-rev__author', r) || {}).textContent || '';
      var mixed = /\b(but|bs|didn'?t|didn’t|not|however|wish|disappoint|expected)\b/i.test(text);  // a 5-star review can still carry a complaint — never feature those
      var title = (($('.prod__title h1') || {}).textContent || '').replace(/\s+/g, ' ').trim().toLowerCase();
      var nameOnly = !text || (title && text.toLowerCase().indexOf(title.slice(0, 24)) > -1) || /\(\d+ ?g\)/.test(text);  // some bodies are just the product name pasted in
      if (score >= 5 && !mixed && !nameOnly && text.length >= 40 && text.length <= 150 && who.trim()) { pick = { text: text, who: who.trim() }; return true; }
      return false;
    });
    if (!pick) return;
    var parts = pick.who.split(/\s+/);
    var name = parts[0] + (parts[1] ? ' ' + parts[1].charAt(0) + '.' : '');
    var q = document.createElement('figure');
    q.className = 'sal-quote';
    q.innerHTML = '<span class="sal-quote__stars" aria-label="5 out of 5 stars">★★★★★</span>' +
      '<blockquote>“' + pick.text.replace(/[<>&]/g, '') + '”</blockquote>' +
      '<figcaption>' + name.replace(/[<>&]/g, '') + ' · verified buyer</figcaption>';
    /* D2C pages: the quote lives inside the collapsed "Details" expander, after the stock/shipping row */
    var fold = $('.sal-details__master-body');
    if (fold) { var tr = $('.sal-trust', fold); if (tr) tr.insertAdjacentElement('afterend', q); else fold.insertAdjacentElement('afterbegin', q); return; }
    var ship = $('.sal-ship', b) || $('product-form', b);
    (ship || b.lastElementChild).insertAdjacentElement('afterend', q);
  }

  /* ---------- wiring ---------- */
  /* ---------- 4c. what each purchase option means, in one line each ---------- */
  function subCopy() {
    var w = $('.kaching-subscriptions__cards-wrapper'); if (!w) return;
    var one = $('.one-time-purchase .kaching-subscriptions__flex-col-center', w);
    if (one && !$('.sal-sub-line', one)) one.insertAdjacentHTML('beforeend', '<span class="sal-sub-line">Pay once · nothing renews</span>');
    var sub = $('.kaching-subscriptions__card-wrapper:not(.one-time-purchase) .kaching-subscriptions__flex-col-center', w);
    if (sub) {
      if (!$('.sal-sub-line', sub)) sub.insertAdjacentHTML('beforeend', '<span class="sal-sub-line"></span>');
      var giftEl = $('.ks-free-gifts__title', w.parentNode);
      var gift = giftEl ? giftEl.textContent.replace(/^\s*\+?\s*Free\s*/i, '').replace(/\s+/g, ' ').trim() : '';
      var anyLadder = false;
      (product && product.selling_plan_groups || []).forEach(function (g) { g.selling_plans.forEach(function (p) { if ((p.price_adjustments || []).length > 1) anyLadder = true; }); });
      setHTML($('.sal-sub-line', sub), (anyLadder ? 'Save more from your second delivery · ' : '') + (gift ? 'free ' + gift.replace(/[<>&]/g, '') + ' with your first delivery · ' : '') + 'skip, pause or cancel anytime');
    }
    /* each frequency row: the ladder in words, and the price after the first delivery */
    var v = variant(); if (!v) return;
    $$('.kaching-subscriptions__selling-plan', w).forEach(function (row) {
      var t = $('.kaching-subscriptions__selling-plan-title', row); if (!t) return;
      var m = /every\s+(.+)$/i.exec(t.textContent.trim()); if (!m) return;
      var key = m[1].trim().toLowerCase().replace(/^1\s+month$/, 'month');
      var pid = null;
      (product.selling_plan_groups || []).forEach(function (g) { g.selling_plans.forEach(function (p) { var pm = /every\s+([^|]+)/i.exec(p.name || ''); if (pm && pm[1].trim().toLowerCase().replace(/^1\s+month$/, 'month') === key) pid = p.id; }); });
      var L = pid && ladder(v, pid); if (!L) return;
      var lab = $('.kaching-subscriptions__selling-plan-label', row);
      if (lab) { lab.classList.add('sal-hidden'); }
      var tw = t.parentNode;
      var line = $('.sal-ladder', tw); if (!line) { line = document.createElement('span'); line.className = 'sal-ladder'; tw.appendChild(line); }
      setHTML(line, pctLine(L));
      var pw = $('.kaching-subscriptions__card-price-wrapper', row);
      if (pw) {
        var nx = $('.sal-next', pw);
        if (L.nextPrice !== null) { if (!nx) { nx = document.createElement('span'); nx.className = 'sal-next'; pw.appendChild(nx); } setHTML(nx, 'then ' + aed(L.nextPrice)); }
        else if (nx) nx.remove();
      }
    });
  }

  function refreshCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); })
      .then(function (c) { cartTotal = c.total_price || 0; }).catch(function () {});
  }
  var queued = false;
  function update() {
    if (queued) return; queued = true;
    requestAnimationFrame(function () {
      queued = false;
      defaultOneTime(); subCopy(); commitLine(); sizeButtons(); shipLine(); quote();
    });
  }

  function getJSON(url, tries) {
    return fetch(url, { headers: { Accept: 'application/json' } }).then(function (r) {
      if (!r.ok) throw new Error(r.status);
      return r.json();
    }).catch(function (e) {
      if (tries > 0) return new Promise(function (ok) { setTimeout(ok, 700); }).then(function () { return getJSON(url, tries - 1); });
      throw e;
    });
  }
  Promise.all([
    getJSON('/products/' + handle + '.js', 2).then(function (p) { product = p; }),
    refreshCart(),
    fetch(WHISK + '.js').then(function (r) { return r.json(); }).then(function (w) { whiskPrice = w.available ? w.price : 0; }).catch(function () {})
  ]).then(function () {
    update();
    var b = block() || document.body;
    new MutationObserver(update).observe(b, { childList: true, subtree: true, attributes: true, attributeFilter: ['value', 'class'] });
    document.addEventListener('change', function () { setTimeout(update, 60); }, true);
    document.addEventListener('click', function () { setTimeout(update, 120); }, true);
    // cart changes (drawer add/remove) move the free-shipping line
    ['cart:refresh', 'cart:updated', 'theme:cart:change'].forEach(function (ev) {
      document.addEventListener(ev, function () { refreshCart().then(update); });
    });
    // the widget can render late; keep the default for the first 4 seconds only
    var n = 0, t = setInterval(function () { defaultOneTime(); update(); if (++n > 8) clearInterval(t); }, 500);
  }).catch(function () {});
})();
